import { useCallback } from 'react';

import type { MultiMetricDataMap } from '../../DataProvider/MultiMetricProvider';
import {
  type UpdateChartContentParams,
  useTextChartContent,
} from '../../TextChartContentProvider/TextChartContentProvider';
import { useChart } from '../ChartProvider';
import { TextRenderer } from './TextRenderer';

export const TextChart = ({
  multiData,
  html,
  isLoading,
}: {
  multiData?: MultiMetricDataMap;
  html?: string;
  isLoading?: boolean;
}) => {
  const { item } = useChart();
  const { updateChartContent } = useTextChartContent();

  const onProcessedContent = useCallback(
    (params: UpdateChartContentParams) => {
      updateChartContent(params);
    },
    [updateChartContent]
  );

  if (!html) return null;

  return (
    <TextRenderer
      content={html}
      multiData={multiData}
      color={item?.plot?.color}
      vAlign={item?.plot?.textVAlign}
      item={item}
      onProcessedContent={onProcessedContent}
      isLoading={isLoading}
    />
  );
};
